export const validateDependentes = (dependentes, plano) => {
    const limiteDependentesPlanos = {
        'ZI': 5,
        'ZISF': 10,
        'ZS': 14,
        'ZSUC': 14,
        'ZP': 5,
        'ZPC': 5,
        'ZCL': 10,
        'ZCLO': 10
    };
    const limiteDependentes = limiteDependentesPlanos[plano];

    if (!limiteDependentes) {
        return [];
    }

    const dependentesAtivos = dependentes.length;

    if (dependentesAtivos >= limiteDependentes) {
        return ['Já possui o limite de dependentes ativos permitido para este plano.'];
    }

    return [];
};
